// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iHYJ","colBig":"styles_colBig__2rliP","colSmall":"styles_colSmall__1g5nB"};